var AuthStrategyEnum = /*#__PURE__*/function (AuthStrategyEnum) {
  AuthStrategyEnum["DEFAULT"] = "DEFAULT";
  AuthStrategyEnum["NP_TOKEN"] = "NP_TOKEN";
  AuthStrategyEnum["NP_CUSTOM_SLIDE"] = "NP_CUSTOM_SLIDE";
  return AuthStrategyEnum;
}(AuthStrategyEnum || {});
var AuthStrategy = AuthStrategyEnum;

export { AuthStrategy as default };
//# sourceMappingURL=AuthStrategyEnum.js.map
